// ROUTERS
import OptionRouter from './OptionRouter';
import FloorPlanRouter from './FloorPlanRouter';

// VIEWS
const MainView = () => import('../views/MainView');
const PhaseView = () => import('../views/PhaseView');
const TypeView = () => import('../views/TypeView');
const BuildingView = () => import('../views/BuildingView');
const StatusView = () => import('../views/StatusView');
const DispositionView = () => import('../views/DispositionView');
const AccessoryView = () => import('../views/AccessoryView');
const FileView = () => import('../views/FileView');
const ImageView = () => import('../views/ImageView');
const FloorPlanView = () => import('../views/FloorPlan/FloorPlanView');
const FloorView = () => import('../views/FloorPlan/FloorView');

export default [
    {
        path:      'o',
        component: OptionRouter,
        children:  [
            {
                path:      'default',
                name:      'project-option',
                component: MainView,
            }, {
                path:      'phases',
                name:      'project-option-phase',
                component: PhaseView,
            }, {
                path:      'buildings',
                name:      'project-option-building',
                component: BuildingView,
            }, {
                path:      'floor-plans',
                component: FloorPlanRouter,
                children:  [
                    {
                        path:      '',
                        name:      'project-option-floor-plan',
                        component: FloorPlanView,
                    }, {
                        path:      'floor/:floorPlanId',
                        name:      'project-option-floor-plan-floor',
                        component: FloorView,
                    }
                ]
            }, {
                path:      'statuses',
                name:      'project-option-status',
                component: StatusView,
            }, {
                path:      'types',
                name:      'project-option-type',
                component: TypeView,
            }, {
                path:      'dispositions',
                name:      'project-option-disposition',
                component: DispositionView,
            }, {
                path:      'accessories',
                name:      'project-option-accessory',
                component: AccessoryView,
            }, {
                path:      'files',
                name:      'project-option-file',
                component: FileView,
            }, {
                path:      'images',
                name:      'project-option-image',
                component: ImageView,
            }
        ]
    }
]
